import { ifnull } from './obj.js'

export const statusOptions = [
  { id: 0, name: '初始', type: 'info' },
  { id: 1, name: '审批中', type: 'warning' },
  { id: 2, name: '已结束', type: 'success' }
]

export const statusMap = statusOptions.reduce((map, option) => {
  map[option.id] = option
  return map
}, {})

export const actionMap = {
  0: '新增',
  1: '更新',
  2: '同意',
  3: '驳回',
  4: '转交',
  5: '指定退回',
  6: '终止'
}

export const modeMap = {
  0: '修改',
  1: '审核'
}

export function isReviewAction(action) {
  return [2, 3, 4, 5, 6].includes(action)
}

/**
 * 单元格基准高度
 */
export const CELL_HEIGHT = 25

export const types = [
  {
    id: 0,
    name: '标签'
  },
  {
    id: 1,
    name: '文本输入框'
  },
  {
    id: 2,
    name: '嵌入编辑框'
  },
  {
    id: 3,
    name: '组织架构选择框'
  },
  {
    id: 4,
    name: '用户选择框'
  },
  {
    id: 5,
    name: '当前时间'
  },
  {
    id: 8,
    name: '指定时间'
  },
  {
    id: 9,
    name: '指定时间范围'
  },
  {
    id: 6,
    name: '勾选框'
  },
  {
    id: 10,
    name: '单选框'
  },
  {
    id: 11,
    name: '复选框'
  },
  {
    id: 12,
    name: '下拉选择框'
  },
  {
    id: 7,
    name: '签名'
  },
  {
    id: 13,
    name: '区域选择框'
  }
]

/**
 * 嵌入编辑框子元素能选择的类型
 */
export const nestedtypes = types.filter((type) => ![2].includes(type.id))

export const subtypeMap = {
  //当前时间
  5: [
    { id: 0, name: 'YYYY年M月D日' },
    { id: 1, name: 'YYYY/MM/DD' },
    { id: 2, name: 'YYYY年M月D日H时m分' }
  ],
  8: [
    { id: 0, name: 'YYYY年M月D日' },
    { id: 1, name: 'YYYY/MM/DD' },
    { id: 2, name: 'YYYY年M月D日H时m分' }
  ],
  9: [
    { id: 0, name: 'YYYY年M月D日' },
    { id: 1, name: 'YYYY/MM/DD' },
    { id: 2, name: 'YYYY年M月D日H时m分' }
  ]
}

export function getDefaultModel() {
  return {
    default: {
      font: {
        size: 12,
        color: '#000000'
      },
      pad: {
        x: 5,
        y: 5
      }
    },
    title: {
      content: '票据标题',
      font: {
        size: 1.8,
        color: '#000000'
      }
    },
    cells: [],
    codeNo: {
      prefix: 'ABCD', //编号前缀,固定值
      dateTimePattern: 0, //日期模式
      incrLength: 5 //自增序号固定长度
    },
    process: {
      steps: []
    },
    nextid: 1,
    mso: [],
    jobTime: null
  }
}

export function getDefaultCell() {
  return {
    id: null,
    type: null,
    value: '',
    rowspan: 1,
    colspan: 1,
    width: null,
    height: null,
    pad: {
      x: null,
      y: null
    },
    align: {
      h: 'center',
      v: 'middle'
    },
    wrap: 'normal',
    font: {
      size: null,
      color: null,
      bold: false
    },
    textDir: 0 //文本排列方向,默认水平(即从左到右)
  }
}

export function getDefaultItem() {
  return {
    id: null,
    type: null,
    value: '',
    width: CELL_HEIGHT * 2,
    height: CELL_HEIGHT,
    pad: {
      x: null,
      y: null
    },
    align: {
      h: null,
      v: null
    },
    wrap: null,
    font: {
      size: null,
      color: null,
      bold: false
    },
    pos: {
      left: 0,
      top: 0
    },
    textDir: 0 //文本排列方向,默认水平(即从左到右)
  }
}

export function getCellFontSize(cell, model) {
  return ifnull(cell.font.size, model.default.font.size, 0)
}

export function getCellFontColor(cell, model) {
  return ifnull(cell.font.color, model.default.font.color)
}

export function getCellPadX(cell, model) {
  return ifnull(cell.pad.x, model.default.pad.x, 0)
}

export function getCellPadY(cell, model) {
  return ifnull(cell.pad.y, model.default.pad.y, 0)
}

export function getComputedCodeNo(model) {
  let codeNo = model.codeNo.prefix
  if (model.codeNo.dateTimePattern === 0) {
    codeNo += new Date().toISOString().slice(0, 7).replace(/-/g, '')
  } else if (model.codeNo.dateTimePattern === 1) {
    codeNo += new Date().toISOString().slice(0, 10).replace(/-/g, '')
  }
  if (model.codeNo.incrLength) {
    codeNo += '0'.repeat(model.codeNo.incrLength - 1) + '1'
  }
  return codeNo
}

export function isFormTarget(type) {
  return [1, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13].includes(type)
}

/**
 *
 * @param {Number} id
 * @param {Object} model
 * @returns {Object|null} 返回单元格或单元格子项对象
 */
export function getTarget(id, model) {
  let target = null
  forEach((item) => {
    if (item.target.id === id) {
      target = item.target
      return true
    }
  }, model.cells)
  return target
}

/**
 * 遍历每个单元格或单元格子项，fn返回true时停止遍历
 */
export function forEach(fn, cells) {
  for (let i = 0; i < cells.length; i++) {
    let row = cells[i]
    for (let j = 0; j < row.items.length; j++) {
      let cell = row.items[j]
      let stop = fn({ target: cell, rowid: i, colid: j })
      if (stop) return
      if (cell.type === 2) {
        for (let k = 0; k < cell.items.length; k++) {
          let item = cell.items[k]
          stop = fn({ target: item, rowid: i, colid: j, index: k })
          if (stop) return
        }
      }
    }
  }
}

/**
 * 遍历审批流程的每个审批人，fn返回true时停止遍历
 */
export function forEachReviewer(fn, steps) {
  for (let stepId = 0; stepId < steps.length; stepId++) {
    let step = steps[stepId]
    for (let index = 0; index < step.reviewers.length; index++) {
      let reviewer = step.reviewers[index]
      let stop = fn(reviewer, stepId, index)
      if (stop) return
    }
  }
}

export function archIdToName(target, archMap) {
  const { value, multiple } = target
  if (multiple) {
    if (value) return value.map((id) => archMap[id]?.map((it) => it.title).at(-1)).join('、')
    return ''
  } else {
    return archMap[value]?.map((it) => it.title).at(-1)
  }
}

export function userIdToName(target, userMap) {
  const { value, multiple } = target
  if (multiple) {
    if (value) return value.map((id) => userMap[id]?.name).join('、')
    return ''
  } else {
    return userMap[value]?.name
  }
}

export function selectIdToName(target) {
  const { value, options, multiple } = target
  if (value === null || value === undefined || value === '') return ''
  if (multiple) {
    const opts = options.split('\n')
    return value.map((id) => opts[id].trim()).join('、')
  } else {
    return options.split('\n')[value].trim()
  }
}

/**
 * 计算原子行的范围
 * @param {Array<{rowid:Number,colid:Number,rowspan:Number,colspan:Number}>} mergedAreas
 * @param {Number} rowid 原始行id
 * @return {Object} 返回原子行的范围
 */
export function calcAtomicRow(mergedAreas, rowid) {
  let start = rowid
  let end = rowid
  for (let area of mergedAreas) {
    let s = Math.max(start, area.rowid)
    let e = Math.min(end, area.rowid + area.rowspan - 1)
    if (s <= e) {
      //如果两个区域在垂直方向上存在交集,则取它们在垂直方向上的并集作为一个整体进行插入
      start = Math.min(start, area.rowid)
      end = Math.max(end, area.rowid + area.rowspan - 1)
    }
  }
  return { start, end }
}

/**
 * 获取所属原子行
 * @param {Array} cells 单元格列表
 * @param {number} rowid 目标行id(即索引)
 * @returns {number|null} 返回所属原子行的行id(即索引)
 */
export function getAtomicRow(cells, rowid) {
  let index = 0
  for (const row of cells) {
    if (row.replicable && index + row.span - 1 >= rowid) return index
    index++
  }
  return null
}

export function getTimestamp(type) {
  let date = new Date()
  if (type === 0) {
    //YYYY年M月D日
    return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
  } else if (type === 1) {
    //YYYY/MM/DD
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
  } else if (type === 2) {
    //YYYY年M月D日H时m分
    return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日' + date.getHours() + '时' + date.getMinutes() + '分'
  } else {
    return ''
  }
}

export function getDefaultValue(target) {
  const type = target.type
  switch (type) {
    case 0:
      return ''
    case 1:
      return ''
    case 2:
      return null
    case 3:
      return target.multiple ? [] : null
    case 4:
      return target.multiple ? [] : null
    case 5:
      return ''
    case 6:
      return null
    case 7:
      return null
    case 8:
      return ''
    case 9:
      return ['', ''] //时间范围
    case 10:
      return ''
    case 11:
      return [] //复选框
    case 12:
      return target.multiple ? [] : null
    case 13:
      return null
    default:
      return null
  }
}

export function getMergedAreas(cells) {
  const areas = []
  cells.forEach((row, rowid) => {
    row.items.forEach((cell, colid) => {
      if (cell.rowspan > 1 || cell.colspan > 1) {
        areas.push({ rowid, colid, rowspan: cell.rowspan, colspan: cell.colspan })
      }
    })
  })
  return areas
}

export function getIdMap(cells) {
  const map = {}
  cells.forEach((row, rowid) => {
    map[row.id] = { type: 'row', row, rowid }
    row.items.forEach((cell, colid) => {
      map[cell.id] = { type: 'cell', row, cell, rowid, colid }
      if (cell.type === 2) {
        //当改变单元格类型为容器项时items属性可能临时为空
        cell.items?.forEach((item, index) => {
          map[item.id] = { type: 'item', row, cell, item, rowid, colid, index }
        })
      }
    })
  })
  return map
}

export function getReviewRequiredIds(steps) {
  const ids = []
  steps.forEach((step) => {
    ids.push(...step.requiredIds)
    step.reviewers.forEach((reviewer) => {
      if (reviewer.requiredIds) {
        ids.push(...reviewer.requiredIds)
      }
    })
  })
  return ids
}

export function getReviewIds(steps) {
  const ids = []
  for (const step of steps) {
    if (step.strategy === 0) {
      step.reviewers.forEach((reviewer) => ids.push(...mapReviewIds(reviewer)))
    } else {
      ids.push(...mapReviewIds(step))
    }
  }
  return ids
}

export function mapReviewIds({ commentId, signId, requiredIds }) {
  const ids = []
  if (commentId !== null) ids.push(commentId)
  if (signId !== null) ids.push(signId)
  if (requiredIds !== null) ids.push(...requiredIds)
  return ids
}

export function collectTargetIdsFromCell(cell) {
  const ids = []
  if (cell?.id != null) ids.push(cell.id)
  if (cell?.type === 2 && Array.isArray(cell.items)) {
    for (const item of cell.items) {
      if (item?.id != null) ids.push(item.id)
    }
  }
  return ids
}

export function collectTargetIdsFromRowRange(model, rowStart, rowEndExclusive) {
  const idSet = new Set()
  for (let i = rowStart; i < rowEndExclusive; i++) {
    const row = model.cells[i]
    if (!row?.items) continue
    for (let j = 0; j < row.items.length; j++) {
      for (const id of collectTargetIdsFromCell(row.items[j])) idSet.add(id)
    }
  }
  return idSet
}

export function collectTargetIdsFromColRange(model, colStart, colEndExclusive) {
  const idSet = new Set()
  for (let i = 0; i < model.cells.length; i++) {
    const row = model.cells[i]
    if (!row?.items) continue
    for (let j = colStart; j < colEndExclusive && j < row.items.length; j++) {
      for (const id of collectTargetIdsFromCell(row.items[j])) idSet.add(id)
    }
  }
  return idSet
}

export function clearProcessRefsForTargetIds(model, ids) {
  const idSet = ids instanceof Set ? ids : new Set(ids)
  if (idSet.size === 0) return false
  let touched = false
  if (model.jobTime != null && idSet.has(model.jobTime)) {
    model.jobTime = null
    touched = true
  }
  const steps = model.process?.steps
  if (!steps?.length) return touched
  for (const step of steps) {
    if (step.commentId != null && idSet.has(step.commentId)) {
      step.commentId = null
      touched = true
    }
    if (step.signId != null && idSet.has(step.signId)) {
      step.signId = null
      touched = true
    }
    if (step.timestampId != null && idSet.has(step.timestampId)) {
      step.timestampId = null
      touched = true
    }
    if (Array.isArray(step.requiredIds)) {
      const next = step.requiredIds.filter((id) => !idSet.has(id))
      if (next.length !== step.requiredIds.length) touched = true
      step.requiredIds = next
    }
    for (const reviewer of step.reviewers || []) {
      if (reviewer.commentId != null && idSet.has(reviewer.commentId)) {
        reviewer.commentId = null
        touched = true
      }
      if (reviewer.signId != null && idSet.has(reviewer.signId)) {
        reviewer.signId = null
        touched = true
      }
      if (reviewer.timestampId != null && idSet.has(reviewer.timestampId)) {
        reviewer.timestampId = null
        touched = true
      }
      if (Array.isArray(reviewer.requiredIds)) {
        const next = reviewer.requiredIds.filter((id) => !idSet.has(id))
        if (next.length !== reviewer.requiredIds.length) touched = true
        reviewer.requiredIds = next
      }
    }
  }
  return touched
}

export function getAreaTarget(cells) {
  let tar = null
  forEach(({ target }) => {
    if (target.type === 13) {
      tar = target
      return true
    }
  }, cells)
  return tar
}

export function getCellPosition(element) {
  const rowid = parseInt(element.dataset?.rowid)
  const colid = parseInt(element.dataset?.colid)
  const absid = parseInt(element.dataset?.absid)
  return { rowid, colid, absid }
}

export function getItemPosition(element) {
  const rowid = parseInt(element.dataset?.rowid)
  const colid = parseInt(element.dataset?.colid)
  const index = parseInt(element.dataset?.index)
  const absid = parseInt(element.dataset?.absid)
  return { rowid, colid, index, absid }
}

export function getTargetElement(event) {
  let target = event.target
  while (true) {
    if (target) {
      if (target.classList?.contains('nested-item')) {
        return { target, type: 'item' }
      } else if (target.classList?.contains('ticket-cell')) {
        return { target, type: 'cell' }
      } else {
        target = target.parentNode
      }
    } else {
      return { target: null, type: null }
    }
  }
}

export default {
  CELL_HEIGHT,
  statusOptions,
  statusMap,
  actionMap,
  modeMap,
  types,
  nestedtypes,
  subtypeMap,
  getDefaultModel,
  getDefaultCell,
  getCellFontSize,
  getCellFontColor,
  getCellPadX,
  getCellPadY,
  getComputedCodeNo,
  getDefaultItem,
  isFormTarget,
  getTarget,
  forEach,
  forEachReviewer,
  isReviewAction,
  archIdToName,
  userIdToName,
  selectIdToName,
  calcAtomicRow,
  getAtomicRow,
  getTimestamp,
  getDefaultValue,
  getMergedAreas,
  getIdMap,
  getReviewRequiredIds,
  getReviewIds,
  mapReviewIds,
  collectTargetIdsFromCell,
  collectTargetIdsFromRowRange,
  collectTargetIdsFromColRange,
  clearProcessRefsForTargetIds,
  getAreaTarget,
  getCellPosition,
  getItemPosition,
  getTargetElement
}
